


































/* Created- 11 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
import SectionForm from "@/Ui-Components/Title/SectionForm.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaBaseView from "../../Base/ParticaBaseView.vue";
import { SectionModel, ListItemDTO } from "../../../Generated/ParticaAPI";
import { ISectionService, SectionService } from "../../../BusinessServices/section";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../../Models/Buttons";
import ParticaTitleBase from "../../Base/ParticaTitleBase.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";

@Component(
	{
		name: "SectionManager",
		components: {
			ParticaError,
			ParticaRowContainer,
			ActionListV2,
			SectionForm,
			ButtonList,
			ParticaCard,
			ParticaView
		}
	})
export default class SectionManager extends ParticaTitleBase {
	private sections: SectionModel[] = new Array<SectionModel>();
	private section: SectionModel = { id: 0, publicationId: 0 } as SectionModel;
	private sectionService: ISectionService;
	@Prop() private id: number;

	private buttons: ButtonConfig[] = [
		{ label: "Add Section", action: eParticaAction.PUBLICATION_SECTION_SAVE, type: ButtonType.OK } as ButtonConfig,
		{ label: "Clear", action: eParticaAction.PUBLICATION_SECTION_CLEAR, type: ButtonType.Normal } as ButtonConfig
	] as ButtonConfig[];

	private listactions: ButtonConfig[] = [ // init our menu for the list.
		{ label: "Select", action: eParticaAction.PUBLICATION_SECTION_SELECT, type: ButtonType.OK } as ButtonConfig,
	];

	private listdata(): ListItemDTO[] {
		const items: ListItemDTO[] = new Array<ListItemDTO>();
		this.sections.forEach(section => {
			if (section.id !== undefined && section.name !== undefined) {
				items.push({ id: section.id.toString(), label: section.name } as ListItemDTO);
			}
		});
		return items;
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.PUBLICATION_SECTION_SAVE: {
					this.section.publicationId = this.id;
					const saved: SectionModel = await this.sectionService.saveSection(this.section);
					await this.init();
					this.section = { id: 0, publicationId: this.id, status: 0 } as SectionModel;
					this.buttons[0].label = "Add Section";
					break;
				}
				case eParticaAction.PUBLICATION_SECTION_CLEAR: {
					this.section = { id: 0, publicationId: this.id, status: 0 } as SectionModel;
					this.buttons[0].label = "Add Section";
					break;
				} case eParticaAction.PUBLICATION_SECTION_SELECT: {
					const selected = this.sections.find(section => (section.id === undefined ? "" : section.id.toString()) === event.item.id);
					if (selected === undefined) {
						this.ShowSnackbar("Unknown section.");
					} else {
						this.section = selected;
						this.buttons[0].label = "Update Section";
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Section Manager";
		await this.init();
		await this.getTitleNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			this.sectionService = this.particaServices.getSectionService();
			this.sections = await this.sectionService.getSections(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
